export default __webpack_public_path__ + "static/media/text.5022917d.svg";